import { OnInit, OnDestroy, Directive } from '@angular/core';
import { Observable, Subject, EMPTY } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';
import { RecordService } from 'app/main/services/record.service';
import { DatasetActionContainerService } from 'app/main/services/datasetACS';
import { TranslateService } from '@ngx-translate/core';
import { AppService } from '../services/app.service';

@Directive()
export abstract class BaseLanguageLoaderComponent implements OnInit{

	_unsubscribeAll: Subject<any>;

	constructor(
		public appService: AppService,
		public translate: TranslateService){
			this._unsubscribeAll = new Subject<any>();
		}

	ngOnInit(): void{
		this.appService.loadingLanguages.next(true);
		this.appService.setLanguages();
		this.appService.languages
		.pipe(takeUntil(this._unsubscribeAll))
		.subscribe((newLangs) => {
			this.appService.loadingLanguages.next(false);
		});
		/**
		 * cambia lingua nel caso fosse necessario
		 */
		// this.languageStaticPages();
	}

	languageStaticPages(): void{
		const lang = localStorage.getItem('locale');
		if (!lang || !['it', 'en'].includes(lang)){
			this.appService.languageChanging.next(true);
			this.appService.languageChange('en').subscribe(newLang => {
				localStorage.setItem('locale', newLang);
				this.translate.use('en').subscribe(() => {
					this.appService.languageChanging.next(false);
				});
			});
		}
	}
}
